export default __webpack_public_path__ + "static/media/loading1.5f8af599.gif";